import { jsx as _jsx } from "react/jsx-runtime";
export function ColorPicker({ color, onChange }) {
    return (_jsx("input", { type: "color", value: color, onChange: (e) => onChange(e.target.value), className: "w-10 h-10 p-1 border rounded" }));
}